import styled from "styled-components";
import { getBreakpoint } from "../../../../../../../common-deprecated/themes/common";
import { theme } from "../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import * as Type from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Type";

export const Wrapper = styled.div`
    margin-top: ${theme.space[3]}px;
    text-align: start;
`;

export const HeaderTitle = styled.div`
    padding-bottom: ${theme.space[3]}px;
    border-bottom: 1px solid ${theme.colors.grey2};

    ${Type.H2} {
        font-family: ${theme.fonts.regular};
        font-size: 2rem;
        @media ${getBreakpoint("up", "lg")} {
            font-size: 2.8rem;
        }
    }
`;

export const Panel = styled.div`
    margin-top: ${theme.space[3]}px;
`;

export const Header = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0 0 ${theme.space[3]}px 0;
`;

export const Title = styled.h3`
    font-family: ${theme.fonts.semiBold};
    font-size: 1.3rem;
    line-height: 2rem;
`;

export const PriceWrapper = styled.div`
    ${Type.H3} {
        font-family: ${theme.fonts.semiBold};
        font-size: 2rem;
        line-height: 1.2;
        text-transform: none;
    }
`;

export const Content = styled.div`
    width: 100%;
    padding: 0;
`;
